import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs, {
    BreadcrumbsItem
} from '../../../../template/MainTheme/components/Breadcrumbs';
import EventGuestContainer from "../components/EventGuest/EventGuestContainer";

type RouterParams = {
    id: string;
};

const EventGuest = () => {
    const { id } = useParams<RouterParams>();

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Evento',
            url: '/events',
            isActive: false
        },
        {
            name: 'Editar Evento #' + id,
            url: '/events/' + id + '/edit',
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Editar Evento #${id}`} breadcrumbs={breadcrumbs} />
            <EventGuestContainer eventId={parseInt(id)} />

        </>
    );
};

export default EventGuest;
